import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { IField, IFormBodySection } from 'app/profile/models/dynamic-form.model';

@Injectable({
    providedIn: 'root',
})
export class DynamicFormService {
    constructor() {}

    toFormArray(sections: IFormBodySection[], data): FormArray {
        const formArr: any = [];
        sections.forEach((section: IFormBodySection) => {
            // Generate the formcontrols only if the form is to be displayed on UI
            if (section.isDisplayedOnUI) {
                if (section.isTableView) {
                    formArr.push(this.toTableFormArray(section.tableDataKey, section.fields, data));
                } else {
                    formArr.push(this.toFormGroup(section.fields, data));
                }
            }
        });
        return new FormArray(formArr);
    }

    toActionArray(actions: any[]): any[] {
        return actions.map((action) => {
            return {
                ...action,
                value: null,
                control: new FormControl(null, [action.requred ? Validators.required : Validators.nullValidator]),
            };
        });
    }

    toFormGroup(fields: IField[], data): FormGroup {
        const group: any = {};
        fields.forEach((field) => {
            const validators = [];
            if (field?.props?.isRequired) {
                validators.push(Validators.required);
            }
            group[field.key] = new FormControl(
                {
                    value: this.getFieldValue(field.key, data) || null,
                    disabled: field.isDisabled,
                },
                { validators },
            );
        });
        return new FormGroup(group);
    }

    toTableFormArray(tableDataKey: string, fields: IField[], data): FormArray {
        const collectionData = this.getFieldValue(tableDataKey, data);
        if (collectionData && collectionData.length > 0) {
            const formArray = collectionData.map((rowData) => this.toFormGroup(fields, rowData));
            return new FormArray(formArray);
        }
        return new FormArray([]);
    }

    getFieldValue(key: any, data): any {
        if (!key || !data) {
            return null;
        }
        if (key.substring(0, 2) === '{{') {
            const str = key
                .substring(2, key.length - 2)
                .split('.')
                .reduce((prev, curr) => {
                    return prev ? data[prev][curr] : '';
                });
            return str;
        } else {
            return data?.[key] ?? '';
        }
    }
}
